class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

// ─── Cart Drawer Upsell ───────────────────────────────────────────
// Variant select → update price, compare price, button variant id
document.addEventListener('change', function (e) {
  const sel = e.target.closest('.js-ud-select');
  if (!sel) return;
  const card = sel.closest('.upsell-drawer__card');
  if (!card) return;
  const opt = sel.options[sel.selectedIndex];
  const priceEl   = card.querySelector('.js-ud-price');
  const compareEl = card.querySelector('.js-ud-compare');
  const addBtn    = card.querySelector('.js-ud-add');
  if (priceEl)   priceEl.textContent = opt.dataset.price || '';
  if (compareEl) {
    compareEl.textContent = opt.dataset.compare || '';
    compareEl.style.display = opt.dataset.compare ? '' : 'none';
  }
  if (addBtn) addBtn.dataset.variantId = opt.value;
});

// Add to cart
document.addEventListener('click', function (e) {
  const btn = e.target.closest('.js-ud-add');
  if (!btn) return;
  e.preventDefault();

  const variantId = btn.dataset.variantId;
  if (!variantId) return;

  btn.classList.add('is-loading');
  btn.disabled = true;

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({
      id: parseInt(variantId, 10),
      quantity: 1,
      sections: ['cart-drawer', 'cart-icon-bubble'],
      sections_url: window.location.pathname
    })
  })
  .then(r => r.json())
  .then(data => {
    btn.classList.remove('is-loading');
    if (data.status && data.status !== 200) {
      btn.disabled = false;
      return;
    }
    btn.classList.add('is-added');
    const textEl = btn.querySelector('.js-ud-add-text');
    if (textEl) textEl.textContent = '✓ Added';

    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && data.sections) {
      cartDrawer.renderContents(data);
    } else {
      window.location.reload();
    }

    setTimeout(() => {
      btn.classList.remove('is-added');
      btn.disabled = false;
      if (textEl) textEl.textContent = '+ ADD';
    }, 2500);
  })
  .catch(err => {
    console.error('[Upsell] Add to cart error:', err);
    btn.classList.remove('is-loading');
    btn.disabled = false;
  });
});

// ─── PDP Upsell ───────────────────────────────────────────────────
// Variant select → update price/compare/button
document.addEventListener('change', function (e) {
  const sel = e.target.closest('.js-pdup-select');
  if (!sel) return;
  const card = sel.closest('.pdp-upsell__card');
  if (!card) return;
  const opt = sel.options[sel.selectedIndex];
  const priceEl   = card.querySelector('.js-pdup-price');
  const compareEl = card.querySelector('.js-pdup-compare');
  const addBtn    = card.querySelector('.js-pdup-add');
  if (priceEl)   priceEl.textContent = opt.dataset.price || '';
  if (compareEl) {
    compareEl.textContent    = opt.dataset.compare || '';
    compareEl.style.display  = opt.dataset.compare ? '' : 'none';
  }
  if (addBtn) addBtn.dataset.variantId = opt.value;
});

// Add to cart
document.addEventListener('click', function (e) {
  const btn = e.target.closest('.js-pdup-add');
  if (!btn) return;
  e.preventDefault();

  const variantId = btn.dataset.variantId;
  if (!variantId) return;

  btn.classList.add('is-loading');
  btn.disabled = true;

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({
      id: parseInt(variantId, 10),
      quantity: 1,
      sections: ['cart-drawer', 'cart-icon-bubble'],
      sections_url: window.location.pathname
    })
  })
  .then(r => r.json())
  .then(data => {
    btn.classList.remove('is-loading');
    if (data.status && data.status !== 200) {
      btn.disabled = false;
      return;
    }
    btn.classList.add('is-added');
    const textEl = btn.querySelector('.js-pdup-text');
    if (textEl) textEl.textContent = '✓ Added!';

    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && data.sections) {
      cartDrawer.renderContents(data);
      setTimeout(() => cartDrawer.open(), 300);
    }

    setTimeout(() => {
      btn.classList.remove('is-added');
      btn.disabled = false;
      if (textEl) textEl.textContent = '+ ADD TO CART';
    }, 2500);
  })
  .catch(err => {
    console.error('[PDP Upsell] Add error:', err);
    btn.classList.remove('is-loading');
    btn.disabled = false;
  });
});
